import { Box, Stack, Typography } from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DemoContainer } from "@mui/x-date-pickers/internals/demo"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { useCallback, useEffect, useState } from "react"
import { toast } from "react-toastify"

export function InputDateRange({
	defaultStart,
	defaultEnd,
	onChange,
	width,
	labelStart = "Fecha Inicio",
	labelEnd = "Fecha Termino",
	format = "DD/MM/YYYY",
}) {
	const [dates, setDates] = useState({
		start: defaultStart,
		end: defaultEnd,
	})

	const handleChangeStart = useCallback((date) => {
		setDates((old) => {
			if (old.end < date) {
				return { ...old, start: date, end: date }
			} else return { ...old, start: date }
		})
	}, [])

	const handleChangEnd = useCallback(
		(date) => {
			if (dates.start?.$d > date?.$d) {
				toast.error("La fecha de termino no puede ser menor a la inicial ", {
					toastId: "range_date",
				})
			}
			setDates((old) => ({ ...old, end: date }))
		},
		[dates.start?.$d]
	)

	useEffect(() => {
		if (!dates.end && dates.start?.isValid()) {
			handleChangEnd(dates.start)
		}

		if (typeof onChange !== "function") return
		onChange(dates)
	}, [handleChangEnd, dates, onChange])

	return (
		<Box>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<DemoContainer components={["DatePicker", "DatePicker"]} sx={{ width }}>
					<Stack
						padding={1}
						direction={"row"}
						spacing={2}
						justifyContent={"space-between"}
						alignItems={"baseline"}
						sx={{ width: "100%" }}
					>
						<DatePicker
							{...{
								label: labelStart,
								value: dates.start,
								onChange: handleChangeStart,
								format,
							}}
							slotProps={{
								textField: {
									helperText: format,
								},
							}}
						/>
						<Typography variant="h5" textAlign={"center"}>
							-
						</Typography>
						<DatePicker
							{...{
								label: labelEnd,
								value: dates.end,
								disabled: !dates.start?.isValid(),
								onChange: handleChangEnd,
								format,
							}}
							slotProps={{
								textField: {
									helperText: format,
								},
							}}
						/>
					</Stack>
				</DemoContainer>
			</LocalizationProvider>
		</Box>
	)
}
